export default function SharedWorker_fn() {
  return new SharedWorker(__webpack_public_path__ + "worker/local.sharedWorker.js", {"name":"sharedWorker"});
}
